<template src="./TeaserSkeletonElement.html"></template>
<style src="./TeaserSkeletonElement.scss" lang="scss"></style>

<script>
  export default {
    name: 'HpTeaserSkeletonElement',
    props: {
      type: String
    }
  }
</script>
